import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false }) {
  const { isAuthenticated, isAdmin, loading, needsOnboarding } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen bg-[var(--bg)] text-zinc-300 flex items-center justify-center">
        <div className="text-sm uppercase tracking-[0.4em] opacity-60">authenticating…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (needsOnboarding && location.pathname !== "/finish-registration") {
    return <Navigate to="/finish-registration" replace />;
  }
  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
